import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import axiosInstance from './axiosConfig';

axios.defaults.baseURL = 'https://api.dktsoft.in/grapes/index.php/api/';
axios.defaults.headers.common['Authorization'] = (localStorage['token'])?localStorage['token']:'na';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const app = createApp(App);
app.config.globalProperties.$apiname = 'https://api.dktsoft.in/grapes/index.php/api/';
app.config.globalProperties.$hostname = 'https://api.dktsoft.in/grapes/'
app.config.globalProperties.$axios = axiosInstance;

app.use(store);
app.use(VueSweetalert2);
app.use(router).mount('#app');